import React from 'react';
import { Quote } from 'lucide-react';
const TESTIMONIALS = [{
  name: 'María Fernández',
  role: 'Docente hace 15 años',
  city: 'Buenos Aires',
  age: 42,
  quote: 'Antes pasaba los domingos planificando. Con este material, recuperé mis fines de semana y mis alumnos están más enganchados que nunca. Las actividades son muy reales.',
  color: 'bg-blue-50'
}, {
  name: 'Carlos Rodríguez',
  role: 'Profesor de Economía',
  city: 'Córdoba',
  age: 38,
  quote: 'Lo que más valoro es el orden. Los chicos entienden hacia dónde vamos. El módulo de Cultura Organizacional es excelente, hicieron unos trabajos prácticos increíbles.',
  color: 'bg-orange-50'
}, {
  name: 'Laura Martínez',
  role: 'Docente Nivel Medio',
  city: 'Rosario',
  age: 35,
  quote: 'Tenía miedo de que fuera muy teórico, pero es súper práctico. Las rúbricas de evaluación me salvaron la vida a la hora de cerrar notas. Muy recomendable.',
  color: 'bg-green-50'
}, {
  name: 'Roberto González',
  role: 'Jefe de Departamento',
  city: 'Mendoza',
  age: 51,
  quote: 'En 20 años de docencia, nunca vi un material tan bien organizado. Cubre todo el programa oficial pero de una forma moderna. Vale cada peso.',
  color: 'bg-purple-50'
}, {
  name: 'Silvina López',
  role: 'Profe principiante',
  city: 'La Plata',
  age: 29,
  quote: 'Empecé este año y estaba perdida. Este material me dio la seguridad que necesitaba para pararme frente al curso. Los chicos ni se enteran que soy nueva.',
  color: 'bg-yellow-50'
}];
export function TestimonialsSection() {
  return <section className="py-20 px-4 bg-white" data-id="element-352">
      <div className="max-w-6xl mx-auto" data-id="element-353">
        <div className="text-center mb-16" data-id="element-354">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-355">
            Lo que dicen otros docentes
          </h2>
          <p className="text-xl text-gray-600" data-id="element-356">
            Colegas de todo el país ya están usando este sistema
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-357">
          {TESTIMONIALS.map((t, i) => <div key={i} className={`p-8 rounded-2xl ${t.color} border border-gray-100 relative`} data-id="element-358">
              <Quote className="absolute top-6 right-6 h-8 w-8 text-gray-300 opacity-50" data-id="element-359" />

              <div className="flex items-center gap-3 mb-4" data-id="element-360">
                <div className="w-10 h-10 rounded-full bg-gray-200 flex items-center justify-center text-gray-500 font-bold text-sm" data-id="element-361">
                  {t.name.charAt(0)}
                </div>
                <div data-id="element-362">
                  <p className="font-bold text-gray-900 leading-none" data-id="element-363">
                    {t.name}
                  </p>
                  <p className="text-xs text-gray-500 mt-1" data-id="element-364">
                    {t.city} • {t.age} años
                  </p>
                </div>
              </div>

              <p className="text-gray-700 italic leading-relaxed mb-4" data-id="element-365">
                "{t.quote}"
              </p>

              <p className="text-xs font-semibold text-gray-500 uppercase tracking-wide" data-id="element-366">
                {t.role}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}